export default __webpack_public_path__ + "static/media/Fulfillment_Pick_Pack.6ce955d3.png";